import FTOBanner from '../../public/fto-logo-full.jpg';

import { Globe, TrendingUp, Users, Shield } from 'lucide-react';

export function FreightTechBanner() {
    return (
        <div className="w-64 h-full bg-gradient-to-br from-slate-50 to-cyan-50  border-slate-200 rounded-xl overflow-hidden">
            {/* Header with logo */}
            <div className="p-5 bg-white border-b border-slate-100">
                <img
                    src={FTOBanner}
                    alt="FreightTech.org - Global Trade Data That Works For You"
                    className="w-full h-auto"
                />
            </div>

            {/* Content section */}
            <div className="p-5 space-y-5">
                {/* Value proposition */}
                <div className="text-center">
                    <h3 className="text-slate-900 mb-2">Transform Your Daily Operations</h3>
                    <p className="text-slate-600 text-sm leading-relaxed">
                        Access reliable data to optimize your operations.
                    </p>
                </div>

                {/* Key features */}
                <div className="space-y-2.5">
                    <div className="flex items-center gap-2.5 text-sm">
                        <div className="flex-shrink-0 w-7 h-7 bg-cyan-100 rounded-full flex items-center justify-center">
                            <Globe className="w-3.5 h-3.5 text-cyan-600" />
                        </div>
                        <span className="text-slate-700">Real-time data</span>
                    </div>

                    <div className="flex items-center gap-2.5 text-sm">
                        <div className="flex-shrink-0 w-7 h-7 bg-blue-100 rounded-full flex items-center justify-center">
                            <TrendingUp className="w-3.5 h-3.5 text-blue-600" />
                        </div>
                        <span className="text-slate-700">Smart planning</span>
                    </div>

                    <div className="flex items-center gap-2.5 text-sm">
                        <div className="flex-shrink-0 w-7 h-7 bg-teal-100 rounded-full flex items-center justify-center">
                            <Users className="w-3.5 h-3.5 text-teal-600" />
                        </div>
                        <span className="text-slate-700">Industry trusted</span>
                    </div>

                    <div className="flex items-center gap-2.5 text-sm">
                        <div className="flex-shrink-0 w-7 h-7 bg-emerald-100 rounded-full flex items-center justify-center">
                            <Shield className="w-3.5 h-3.5 text-emerald-600" />
                        </div>
                        <span className="text-slate-700">Secure platform</span>
                    </div>
                </div>

                {/* Social proof */}
                <div className="text-center pt-2 border-t border-slate-100">
                    <p className="text-xs text-slate-500">
                        Join industry players optimizing daily operations
                    </p>
                </div>
            </div>
        </div>
    );
}

export default FreightTechBanner;